import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationMeta {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

interface NotificationPaginationProps {
    meta: PaginationMeta;
    onPageChange: (page: number) => void;
    onPerPageChange: (perPage: number) => void;
}

export const NotificationPagination: React.FC<NotificationPaginationProps> = ({
    meta,
    onPageChange,
    onPerPageChange,
}) => {
    const { current_page, last_page, per_page, total } = meta;
    const startItem = (current_page - 1) * per_page + 1;
    const endItem = Math.min(current_page * per_page, total);

    return (
        <div className="flex items-center justify-between p-4 border-t">
            <div className="text-sm text-muted-foreground">
                Showing {startItem} to {endItem} of {total} results
            </div>
            <div className="flex items-center gap-2">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(current_page - 1)}
                    disabled={current_page <= 1}
                    aria-label="Previous page"
                    title="Previous page"
                >
                    <ChevronLeft className="h-4 w-4" />
                </Button>
                <span className="text-sm">
                    Page {current_page} of {last_page}
                </span>
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(current_page + 1)}
                    disabled={current_page >= last_page}
                    aria-label="Next page"
                    title="Next page"
                >
                    <ChevronRight className="h-4 w-4" />
                </Button>
            </div>
        </div>
    );
};
